import { Component, OnInit } from '@angular/core';
import { GipReqReplotForm, GipRequestDnloadForm } from 'src/app/workflow/download/gipRequestDnloadFormModel';
import { Router, ActivatedRoute } from '@angular/router';
import { SharingDataService } from 'src/app/Services/sharing-data.service';
import { DownloadService } from '../download.service';

@Component({
  selector: 'app-gip-req-replot-form',
  templateUrl: './gipReqReplotForm.component.html',
  styleUrls: ['./gipReqReplotForm.component.css']
})
export class GipReqReplotFormComponent implements OnInit {

  constructor(
    private downloadService: DownloadService,
    private router: Router,
    private route: ActivatedRoute,
    private shareData: SharingDataService
  ) { }

  modelInput = GipReqReplotForm;
  resourceDefinition: any;
  urlStringBase = 'Data/MS_REQ_N';
  g3e_fid: string;
  isEdit: boolean;
  g3e_id: string;
  isNew: boolean;
  language;
  dnloadModel = GipRequestDnloadForm;

  formular = [
    { formControlName: "G3E_FID", readonly: true, editReadonly: true, newReadonly: true, inputString: true, title: "cptn_DisplayRequest" },
    { formControlName: "PERSON_ID", hidden: true, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "CONTRACT_ID", hidden: true, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "REQUESTOR", hidden: true, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "ROLE", hidden: true, readonly: true, editReadonly: false, newReadonly: false, inputString: true },
    { formControlName: "FULLNAME", inputString: true, readonly: true, editReadonly: false, newReadonly: false, },
    { formControlName: "PERSON_EMAIL", inputString: true, readonly: true, editReadonly: false, newReadonly: false, },
    { formControlName: "DELIVERY_STATE", hidden: true, readonly: true, editReadonly: true, newReadonly: true, picklist: "V_MS_DELIVERY_STATE_VL_T" },
    { formControlName: "REQUEST_STATE", hidden: true, readonly: true, editReadonly: true, newReadonly: true, picklist: "V_MS_REQUEST_STATE_VL_T" },
    { formControlName: "ACTIVITY_TYPE", hidden: true, readonly: true, editReadonly: true, newReadonly: true, picklist: "V_MS_ACTIVITY_TYPE_VL_T" },
    { formControlName: "REASON_TYPE", hidden: true, readonly: true, editReadonly: true, newReadonly: true, picklist: "V_MS_REASON_TYPE_VL_T" },
    { formControlName: "SCALE", hidden: true, required: true, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "FORMAT", hidden: true, required: true, readonly: true, editReadonly: true, newReadonly: true, inputString: true },
    { formControlName: "BEGIN_ACTIVITY_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "beginActivityDt" },
    { formControlName: "END_ACTIVITY_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "endActivityDt" },
    { formControlName: "REQUEST_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "requestDt" },
    { formControlName: "EXPIRATION_DT", readonly: true, editReadonly: true, newReadonly: true, datepicker: true, datepickerType: "expirationDt" },
    { formControlName: "RESPONSIBLE_PERSON", inputString: true, readonly: true, editReadonly: false, newReadonly: false,},
    { formControlName: "RESPONSIBLE_PERSON_TEL_NUM", inputString: true, readonly: true, editReadonly: false, newReadonly: false },
    { formControlName: "LOCATION_DESC", inputString: true, readonly: true, editReadonly: false, newReadonly: false },
    { formControlName: "SEARCH_METHOD", hidden: true, inputString: true, readonly: true, editReadonly: false, newReadonly: false },
    { formControlName: "ADDRESS_ID", hidden: true, inputString: true, readonly: true, editReadonly: false, newReadonly: false },
    { formControlName: "PARCEL_ID", hidden: true, inputString: true, readonly: true, editReadonly: false, newReadonly: false },
    { formControlName: "LOCATION", inputString: true, readonly: true, editReadonly: false, newReadonly: false },
    { formControlName: "COMPANY", inputString: true, readonly: true, editReadonly: false, newReadonly: false },
  ];

  ngOnInit(): void {
    this.modelInput.reset();
    this.shareData.currentResourceDefinition.subscribe((data) => this.resourceDefinition = data);
    this.shareData.currentLanguage.subscribe((data) => this.language = data);
    this.getParams();
    if(!this.isNew)
      this.getData();

  }

  getParams(){
    this.g3e_fid = this.dnloadModel.value.G3E_FID;
    this.g3e_id = this.dnloadModel.value.G3E_ID;
    this.setReadonly();
  }

  getUrlParams() {
    this.route.queryParams
      .subscribe(params => {
        if (params.g3e_fid != undefined) {
          this.g3e_fid = params.g3e_fid;
          this.setReadonly();
        } else this.changeToNew();

        if (params.g3e_id != undefined) {
          this.g3e_id = params.g3e_id;
          this.setReadonly();
        }

        if (params.isEdit != undefined) {
          this.isEdit = params.isEdit;
          this.setReadonly();
        }
      });
  }

  setReadonly() {
    if (!this.isEdit && this.isEdit == undefined) {
      this.changeToDisplay();
    } else if (this.isEdit) {
      this.changeToEdit();
    }
  }


  changeToEdit() {
    this.formular.forEach(element => {
      if (element.editReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }

  changeToDisplay() {
    this.formular.forEach(element => {
      element.readonly = true;
    });
  }

  changeToNew() {
    this.isNew = true;
    this.formular.forEach(element => {
      if (element.newReadonly) {
        element.readonly = true;
      } else {
        element.readonly = false;
      }
    });
  }


  getData() {
    let requestUrl = [
      `${this.urlStringBase}?$filter=G3E_FID eq ${this.g3e_fid}`,
    ];
    var data = this.downloadService.getData(requestUrl, (data) => {
      if (data[0][0] != undefined) {
        for (var dataElement in data[0][0]) {
          for (var element in this.modelInput.value) {
            if (dataElement == element) {
              this.modelInput.controls[element].setValue(data[0][0][dataElement])
            }
          }
        }
      }
    });
  }

  backToRequestDnloadForm() {
    if(this.g3e_fid != undefined){
      this.router.navigate(['/gipReqDnloadForm']);
    }
  }

  btnReplotAction(){
    this.downloadService.postData(`plot/replot/${this.g3e_fid}/${this.language}`, {}, (data) =>  {
      this.router.navigate(['/statisticForm'], {queryParams: {id: `g3e_fid eq ${data.g3e_fid}`}});
    });
  }
}
    